import { gql } from "@apollo/client";

// this is not wrapper api
export const GET_NATIONALITIES_QUERY = gql`
  query NationalityMasterList {
    nationalityMasterList {
      responseData {
        description
        id
        name
        value
      }
    }
  }
`;

export const GET_LOCATIONS_WRAPPER = gql`
  query Location($location: String!) {
    location(location: $location) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_HOTELSLIST_WRAPPER = gql`
  query HotelsList($sId: String!, $cityId: String!) {
    hotelsList(sId: $sId, cityId: $cityId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_ADDRESSES_WRAPPER = gql`
  query Addresses($sId: String!) {
    addresses(sId: $sId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_EXTRADETAILS_WRAPPER = gql`
  query ExtraDetails($sid: String!, $hotelid: String!) {
    extraDetails(sid: $sid, hotelid: $hotelid) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_HOTELLEVELFILTER_WRAPPER = gql`
  query HotelLevelFilter($sId: String!) {
    hotelLevelFilter(sId: $sId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_GETALLCURRENTSUPPLIERS_WRAPPER = gql`
  query AllCurrentSuppliers($sId: String!) {
    allCurrentSuppliers(sId: $sId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_GETACTIVITIESCURRENTSUPPLIERS_WRAPPER = gql`
  query ActivitySuppliers($searchKey: String!) {
    activitySuppliers(searchKey: $searchKey) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_HOTEL_INFO_WRAPPER = gql`
  mutation hotelInfo($hotelInfoDTO: String!) {
    hotelInfo(hotelInfoDTO: $hotelInfoDTO) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_HOTEL_RATES_WRAPPER = gql`
  mutation hotelRates($hotelRatesDTO: String!) {
    hotelRates(hotelRatesDTO: $hotelRatesDTO) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_HOTEL_RATES_MORE_WRAPPER = gql`
  mutation hotelRatesMore($hotelRatesMoreDTO: String!) {
    hotelRatesMore(hotelRatesMoreDTO: $hotelRatesMoreDTO) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_ROOM_OPTIONS_RATES_WRAPPER = gql`
  mutation roomOptionsRates($input: String!) {
    roomOptionsRates(input: $input) {
      responseData
    }
  }
`;

export const GET_ROOM_OPTIONS_RATES_MORE_WRAPPER = gql`
  mutation roomOptionsRatesMore($input: String!) {
    roomOptionsRatesMore(input: $input) {
      responseData
    }
  }
`;

export const MULTIROOM_MEAN_RATE_WRAPPER = gql`
  mutation postMeanRate($input: String!) {
    postMeanRate(meanRateDTO: $input) {
      responseData
      messageCode
      messageDescription
      successTypeCode
    }
  }
`;

export const GET_HOTELSEARCH_WRAPPER = gql`
  mutation PostHotelSearch($hotelSearchDTO: String!) {
    postHotelSearch(hotelSearchDTO: $hotelSearchDTO) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_CANCELLATIONPOLICY_WRAPPER = gql`
  mutation cancellationPolicy($input: String!) {
    cancellationPolicy(input: $input) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_PREBOOK_WRAPPER = gql`
  mutation PostPreBook($preBookDTO: String!) {
    postPreBook(preBookDTO: $preBookDTO) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_CHECKOUT_WRAPPER = gql`
  mutation PostCheckOut($bookingDetails: String!) {
    postCheckOut(request: $bookingDetails) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_DESTINATION_WRAPPER = gql`
  query Destination(
    $location: String!
    $searchKey: String!
    $hubSearchId: String!
  ) {
    destination(
      location: $location
      searchKey: $searchKey
      hubSearchId: $hubSearchId
    ) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_DESTINATION_ACTIVITY_WRAPPER = gql`
  query DestinationNew(
    $location: String!
    $searchKey: String!
    $hubSearchId: String!
  ) {
    destinationNew(
      location: $location
      searchKey: $searchKey
      hubSearchId: $hubSearchId
    ) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_AIRPORT_WRAPPER = gql`
  query Airport($id: String!, $searchKey: String!, $hubSearchId: String!) {
    airport(id: $id, searchKey: $searchKey, hubSearchId: $hubSearchId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACCOMMODATION_WRAPPER = gql`
  query Accommodation($id: String!) {
    accommodation(id: $id) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_TRANSFERSEARCH_WRAPPER = gql`
  mutation PostTransfersSearch($transferSearchDTO: String!) {
    postTransfersSearch(transferSearchDTO: $transferSearchDTO) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_TRANSFERSLIST_WRAPPER = gql`
  query TransfersList($id: String!) {
    transfersList(id: $id) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_TRANSFER_PREBOOK_WRAPPER = gql`
  mutation PostTransfersPrebook($transfersPrebookDTO: String!) {
    postTransfersPrebook(transfersPrebookDTO: $transfersPrebookDTO) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_TRANSFER_CHECKOUT_WRAPPER = gql`
  mutation PostTransfersCheckOut(
    $input: String!
    $sid: String!
    $hubSearchId: String!
  ) {
    postTransfersCheckOut(input: $input, sid: $sid, hubSearchId: $hubSearchId) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_CHECKOUT_WRAPPER = gql`
  mutation postActivityCheckout(
    $input: String!
    $sid: String!
    $hubSearchId: String!
  ) {
    postActivityCheckout(input: $input, sid: $sid, hubSearchId: $hubSearchId) {
      responseData
      successTypeCode
    }
  }
`;

// export const GET_TRANSFER_PREBOOK_WRAPPER = gql`
//   mutation PostTransfersPrebook($transfersPrebookDTO: TransfersPrebookDTOInput!) {
//     postTransfersPrebook(transfersPrebookDTO: $transfersPrebookDTO) {
//       responseData
//       successTypeCode
//     }
//   }
// `;

export const GET_ACTIVITY_AGEBAND_WRAPPER = gql`
  query ActivityAgeBand($productCode: String!, $ts: String!) {
    activityAgeBand(productCode: $productCode, ts: $ts) {
      responseData
      successTypeCode
      correlationId
      messageCode
      messageDescription
    }
  }
`;

export const GET_ACTIVITY_CATEGORIES_WRAPPER = gql`
  query ActivityCategories($ts: String!) {
    activityCategories(ts: $ts) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_EXTRADETAILS_WRAPPER = gql`
  query ActivityExtraDetails($productIds: String!, $ts: String!) {
    activityExtraDetails(productIds: $productIds, ts: $ts) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_SEARCH_WRAPPER = gql`
  mutation PostActivitySearch($search: String!) {
    postActivitySearch(search: $search) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_LIST_WRAPPER = gql`
  query ActivityList($ts: String!) {
    activityList(ts: $ts) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_PRODUCTINFO_WRAPPER = gql`
  mutation postActivityProductInfo($search: String!) {
    postActivityProductInfo(search: $search) {
      responseData
      messageCode
      messageDescription
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_ALLDETAILS_WRAPPER = gql`
  mutation PostActivityAllDetails($search: String!) {
    postActivityAllDetails(search: $search) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_ACTIVITY_PREBOOK_WRAPPER = gql`
  mutation postActivityPrebook($search: String!) {
    postActivityPrebook(search: $search) {
      responseData
      successTypeCode
    }
  }
`;

export const GET_BOOKING_DETAILS_QUERY = gql`
  query BookingDetailsByID($id: String!) {
    bookingDetailsByID(id: $id) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const POST_LOGIN = gql`
  mutation {
    login {
      responseData
    }
  }
`;

export const GET_AIRLINES_QUERY = gql`
  query TransfersAirlines($searchKey: String!, $hubSearchId: String!) {
    transfersAirlines(searchKey: $searchKey, hubSearchId: $hubSearchId) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
      totalRecords
    }
  }
`;

export const BOOKING_DETAILS_BY_BID = gql`
  query BookingDetails($bid: String!) {
    bookingDetailsByBid(bid: $bid) {
      responseData {
        agent_hierarchy
        agent_ip
        agent_reference
        auto_mapping
        last_updated_ip
        city
        nationality
        supplier_reference
        agent_name
        conversion_amount
        bid
        booking_date
        booking_reference
        booking_type
        booking_name
        cancel_by_date
        channel
        checkin_date
        checkout_date
        currency
        grn_booking_status
        grn_recheck_price_changed
        host_name
        is_amendment
        is_rebooking
        is_rebooking_confirmed
        nbr
        no_of_adults
        no_of_children
        no_of_nights
        no_of_rooms
        non_refundable
        pan_required
        payment_type
        product_type
        purpose_of_travel
        rebooker_email
        rebooking_date
        request_type
        retry_booking
        roe_uuid
        search_id
        source_market
        status
        supplier_code
        supports_amendment
        supports_cancellation
        temp_id
        under_cancellation
        version
        agentPricingCommission {
          agent_id
          agent_level
          base_price_for_comission
          billable_amount
          commision_percntage
          commission_amount
          currency
        }
        bookingHolder {
          email
          gst_number
          name
          nationality
          pan_number
          phone_number
          surname
          title
        }
        bookingInfo {
          address
          category
          category_code
          country_code
          country_name
          description
          destination_code
          destination_name
          email
          fax
          featured_hotel
          hotel_code
          image
          inventory_type
          latitude
          longitude
          name
          phone_number
          recommended_hotel
          supplier_hotel_code
          bookingItems {
            boarding_details
            currency
            includes_boarding
            non_refundable
            other_inclusions
            price
            rate_key
            room_code
            vendor_hotel_name
            rateComments {
              title
              value
            }
            roomsInfos {
              children_ages
              no_of_adults
              no_of_children
              no_of_infants
              no_of_rooms
              pax_ids
              room_description
              room_type
            }
            cancellation_policy
            cancellation_policy_buffer
            original_cancellation_policy
          }
          paxesList {
            age
            name
            pax_id
            surname
            title
            type
          }
        }
        bookingMarkupBreakUp {
          base_amount
          currency
          grouping
          markup
          markup_amount
          markup_type
        }
        bookingPriceBreakUp {
          amount
          amount_type
          currency
          grouping
          included
          name
          percent
        }
        bookingsOtherInfo {
          additional_info
          booking_roe
          commissionable_percentage
          commissionable_price
          currency_converter
          currency_uuid
          supplier_booking_currency
          supplier_booking_price
        }
        agent_id
        booking_comment
        total_price
      }
      messageDescription
      totalRecords
      messageCode
      successTypeCode
    }
  }
`;

export const GET_CURRENCY_LIST_WRAPPER = gql`
  query TransfersList {
    transfersList {
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_CITY_BY_COUNTRY_WRAPPER = gql`
  query City($country: String) {
    city(country: $country) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const ADD_PG_TRANSACTION_CALL_WRAPPER = gql`
  mutation AddPGTransaction(
    $paymentGatewayTransaction: PaymentGatewayTransactionVMInput!
  ) {
    addPGTransaction(paymentGatewayTransaction: $paymentGatewayTransaction) {
      responseData {
        agent_id
        agent_uuid
        bid
        billing_location
        country
        created_by
        created_by_role
        created_on
        id
        ip_address
        l1_agent_id
        l1_agent_uuid
        order_amount
        order_currency
        order_date
        order_id
        pay_gateway
        pay_reason
        payment_confirmation_date
        payment_status
        payment_type
        payment_type_ui
        pg_charge_amount
        pg_charge_currency
        process_type
        secure_id
        temp_bid
        transaction_id
        type_of_card
        updated_by
        updated_by_role
        updated_on
        user_id
        validation_status
      }
      successTypeCode
    }
  }
`;

export const GENERATE_HASH512_WRAPPER = gql`
  query GenerateHash512($text: String!) {
    generateHash512(text: $text) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const VALIDATE_PANS_WRAPPER = gql`
  mutation PostPans(
    $input: String!
    $searchKey: String!
    $hubSearchId: String!
    $agentId: UUID
  ) {
    postPans(
      input: $input
      searchKey: $searchKey
      hubSearchId: $hubSearchId
      agentId: $agentId
    ) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
      totalRecords
    }
  }
`;

export const UPDATE_VALIDATION_STATUS_MUTATION = gql`
  mutation UpdateValidationStatus(
    $updatePGValidationStatus: UpdatePGValidationStatusVMInput!
  ) {
    updateValidationStatus(
      updatePGValidationStatus: $updatePGValidationStatus
    ) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      responseData {
        is_success
        online_payment_status
        transaction_date
      }
    }
  }
`;

export const ADD_DUPLICATE_BOOKING_MAIL_DATA_QUERY = gql`
  mutation addDuplicateBookingMailData(
    $addDuplicateBookingMailData: AddDuplicateBookingVMInput!
  ) {
    addDuplicateBookingMailData(
      duplicateBooking: $addDuplicateBookingMailData
    ) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      responseData {
        created_by
        created_on
        id
        latest_bid
        mail_sent_status
        previous_bid
        product_type
      }
    }
  }
`;
